// http://webdesign-finder.com/chiropractor/

import React                       from 'react';
import ReactDOM                    from 'react-dom';
import { Provider }                from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import createStore                 from './store/createStore';
import AppContainer                from 'pursuit/components/AppContainer';
import ScrollToTop                 from './routes/ScrollToTop';

const store  = createStore();

const wrappedApp = (
    <Provider store={store}>
        <Router>
            <ScrollToTop />
            <AppContainer />
        </Router>
    </Provider>
);

ReactDOM.render(wrappedApp, document.getElementById('root'));
